import { QuestionResponse } from "./QuestionResponse";

export class ReviewFormDataToSubmit {
    token: string;
    isAnonymous: boolean;
    responses: QuestionResponse[];
}